module.exports = __webpack_public_path__ + "img/stock_availability_rate.4a287838.svg";